var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c("PageHeader", { attrs: { title: "Overview" } }, [
            _c("h4", { staticClass: "quota-left" }, [
              _vm._v("Quota(s) Left：" + _vm._s(_vm.quota)),
            ]),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.overviewListLoading,
                  expression: "overviewListLoading",
                },
              ],
              attrs: {
                data: _vm.overviewList,
                "element-loading-text": "Loading...",
                "header-row-class-name": "table-header",
                "row-class-name": "table-row",
              },
            },
            [
              _c("el-table-column", { attrs: { prop: "Name" } }),
              _c("el-table-column", {
                attrs: { prop: "Submitted", label: "Submitted" },
              }),
              _c("el-table-column", {
                attrs: { prop: "Completed", label: "Completed" },
              }),
              _c("el-table-column", {
                attrs: { prop: "ToBePushed", label: "To Be Pushed" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-wrapper config" },
        [
          _c(
            "PageHeader",
            { attrs: { title: "Parameter Configuration" } },
            [
              _vm.admin
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: {
                        click: function ($event) {
                          _vm.generateVisable = true
                        },
                      },
                    },
                    [_vm._v(" Newsletter Tools ")]
                  )
                : _vm._e(),
              _vm.admin
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: {
                        click: function ($event) {
                          _vm.uploadVisible = true
                        },
                      },
                    },
                    [_vm._v(" Upload Newsletter ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.configListLoading,
                  expression: "configListLoading",
                },
              ],
              attrs: {
                data: _vm.configList,
                "element-loading-text": "Loading...",
                "header-row-class-name": "table-header",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "ConfigName",
                  label: "Setting",
                  "min-width": "250",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ConfigValue",
                  label: "Value",
                  "min-width": "400",
                  formatter: _vm.passwordFormatter,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "options",
                  label: "Operation",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-edit" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditRow(row)
                              },
                            },
                          },
                          [_vm._v(" Edit ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.admin
        ? _c(
            "div",
            { staticClass: "table-wrapper config" },
            [
              _c("PageHeader", { attrs: { title: "TA Configuration" } }),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.configListLoading,
                      expression: "configListLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.taList,
                    "element-loading-text": "Loading...",
                    "header-row-class-name": "table-header",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "ConfigName",
                      label: "Setting",
                      "min-width": "250",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "options",
                      label: "Operation",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", icon: "el-icon-edit" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleTaRow(row)
                                    },
                                  },
                                },
                                [_vm._v(" Edit ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2051222201
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("EditConfigDialog", {
        attrs: { visible: _vm.editConfigDialogVisible, data: _vm.editRow },
        on: {
          "update:visible": function ($event) {
            _vm.editConfigDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.editRow = $event
          },
          success: _vm.onSuccess,
        },
      }),
      _c("TaConfigDialog", {
        ref: "taConfig",
        attrs: { visible: _vm.taConfigDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.taConfigDialogVisible = $event
          },
          success: _vm.onSuccess,
          openInfo: _vm.openInfo,
        },
      }),
      _c("TaInfoDialog", {
        attrs: {
          visible: _vm.taInfoDialogVisible,
          taInfoForm: _vm.taInfoForm,
          taInfoTitle: _vm.taInfoTitle,
        },
        on: {
          "update:visible": function ($event) {
            _vm.taInfoDialogVisible = $event
          },
          success: _vm.initTaList,
        },
      }),
      _c("UploadDialog", {
        attrs: {
          visible: _vm.uploadVisible,
          maximumSize: _vm.maximumSize,
          data: _vm.editRow,
        },
        on: {
          "update:visible": function ($event) {
            _vm.uploadVisible = $event
          },
          "update:data": function ($event) {
            _vm.editRow = $event
          },
          success: _vm.onSuccess,
        },
      }),
      _c("GenerateDialog", {
        attrs: {
          visible: _vm.generateVisable,
          maximumSize: _vm.maximumSize,
          data: _vm.editRow,
        },
        on: {
          "update:visible": function ($event) {
            _vm.generateVisable = $event
          },
          "update:data": function ($event) {
            _vm.editRow = $event
          },
          success: _vm.onSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }